import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ObjectLiteral } from 'src/app/_models/user';
import { BoardingPassService } from 'src/app/_services/api/boardingpass/boardingpass.service';
import { FlightService } from 'src/app/_services/api/flight/flight.service';
import { LanguageService } from 'src/app/_services/api/language/language.service';
import { LoggerService } from 'src/app/_services/ui/logger/logger.service';

@Component({
  selector: 'ua-boarding-pass-viewer',
  templateUrl: './boarding-pass-viewer.component.html',
  styleUrls: ['./boarding-pass-viewer.component.scss'],
  host: {
    '[style.display]': '"flex"',
    '[style.flex-direction]': '"column"',
    '[style.overflow]': '"auto"'
  }
})
export class BoardingPassViewerComponent implements OnInit {

  @Output() modalDismiss = new EventEmitter();

  languageSubscription: Subscription;
  pageConstants: ObjectLiteral = {};
  boardingPasses: Array<any> = [];
  isTravelReady: boolean = false;
  index: number = 0;
  activeSegmentIndex: number = 0;

  constructor(
    private flightService: FlightService,
    private boardingPassService: BoardingPassService,
    private languageService: LanguageService,
    private logger: LoggerService) {
      this.languageSubscription = this.languageService.languageChanges.subscribe(() => {
        this.pageConstants = this.languageService.constants?.boardingPassScanner || {};
      })

  }

  ngOnInit(): void {
    this.boardingPasses = this.boardingPassService.boardingPassDetails?.segmentList;
    this.setTravelReady();
    this.activeSegmentIndex = this.getActiveSegmentIndex(this.flightService.activeSegment.segmentNumber,this.flightService.activeTraveler.givenName);
    this.index = this.activeSegmentIndex;
    this.isTravelReady = this.flightService.flightDetails?.travelReady;
    this.logger.debug('boardingpasses',this.boardingPasses);
  }

  getActiveSegmentIndex(segmentNumber: any,firstName: string) {
    let activeSegmentIndex = this.boardingPasses.findIndex(p => p.segmentNumber == segmentNumber && p.passengerList.firstName == firstName);
    return activeSegmentIndex == -1 ? 0 : activeSegmentIndex;
  }

  setTravelReady() {
    let travelers = this.flightService.flightDetails.allTravelers;
    this.boardingPasses.forEach((segment) => {
      travelers.forEach((traveler) => {
        if (segment.passengerList.firstName == traveler.givenName) {
          traveler.travelReadiness.forEach((travelerStatus) => {
            segment.passengerList.isTravelReady = travelerStatus.isTravelReady;
          });
        }
      });
    });
  };

  closeModal() {
    this.modalDismiss.emit();
  }
  
  ngonDestroy(): void {
    this.languageSubscription && this.languageSubscription.unsubscribe();
  }
}
